import { useState, useEffect, useRef } from 'react';
import { PayeeSuggestion } from '../types';
import { api } from '../services/api';

export function usePayeeSearch(accountId: number | null) {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState<PayeeSuggestion[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const debounceRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (query.length < 3 || !accountId) {
      setSuggestions([]);
      setIsOpen(false);
      return;
    }

    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      try {
        const data = await api.searchPayees(accountId, query);
        const parsed = data.map(s => ({
          ...s,
          payment: s.payment !== null ? Number(s.payment) : null,
          deposit: s.deposit !== null ? Number(s.deposit) : null,
        }));
        setSuggestions(parsed);
        setIsOpen(parsed.length > 0);
      } catch (err) {
        console.error('Payee search failed:', err);
      }
    }, 200);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [query, accountId]);

  const close = () => {
    setIsOpen(false);
    setSuggestions([]);
  };

  return { query, setQuery, suggestions, isOpen, close };
}
